export var SoilType;
(function (SoilType) {
    SoilType["Light"] = "0";
    SoilType["Medium"] = "1";
    SoilType["Heavy"] = "2";
})(SoilType || (SoilType = {}));
